export default __webpack_public_path__ + "static/media/sign-out.dcaae730.svg";